/**
 * Utility functions for tracking module completion status
 */

type WorkflowStatus = {
  module1: boolean;
  module2: boolean;
  module3: boolean;
  module4: boolean;
  jobs: boolean; // Add job monitoring status
};

/**
 * Get the completion status for modules from localStorage
 * @param workflowId The ID of the workflow
 * @returns WorkflowStatus object with completion status for each module
 */
export const getWorkflowStatus = (workflowId: string | undefined): WorkflowStatus => {
  if (!workflowId) {
    return {
      module1: false,
      module2: false,
      module3: false,
      module4: false,
      jobs: false // Add job monitoring status
    };
  }

  return {
    module1: localStorage.getItem(`workflow_${workflowId}_module1_completed`) === 'true',
    module2: localStorage.getItem(`workflow_${workflowId}_module2_completed`) === 'true',
    module3: localStorage.getItem(`workflow_${workflowId}_module3_completed`) === 'true',
    module4: localStorage.getItem(`workflow_${workflowId}_module4_completed`) === 'true',
    jobs: localStorage.getItem(`workflow_${workflowId}_jobs_completed`) === 'true' // Add job monitoring status
  };
};

/**
 * Update the completion status for a specific module
 * @param workflowId The ID of the workflow
 * @param module The module number (1-4)
 * @param isComplete Whether the module is complete
 */
export const updateModuleStatus = (
  workflowId: string | undefined, 
  module: 1 | 2 | 3 | 4 | 'jobs', // Include 'jobs' module
  isComplete: boolean
): void => {
  if (!workflowId) return;
  
  localStorage.setItem(
    `workflow_${workflowId}_${module}_completed`, 
    isComplete ? 'true' : 'false'
  );
};

/**
 * Reset all module completion status for a workflow
 * @param workflowId The ID of the workflow
 */
export const resetWorkflowStatus = (workflowId: string | undefined): void => {
  if (!workflowId) return;
  
  localStorage.removeItem(`workflow_${workflowId}_module1_completed`);
  localStorage.removeItem(`workflow_${workflowId}_module2_completed`);
  localStorage.removeItem(`workflow_${workflowId}_module3_completed`);
  localStorage.removeItem(`workflow_${workflowId}_module4_completed`);
  localStorage.removeItem(`workflow_${workflowId}_jobs_completed`); // Add job monitoring status
};
